import React, { useState } from "react";
import { useIntl } from "react-intl";
import { saveAcceptanceOfTermsAndPolicies } from "../../../../api";
import "./styles.scss";

const TermsAndPoliciesModal = ({ data, onClose }) => {
  const termsOfUse = data['termos_de_uso'];
  const privacyPolicy = data['politica_privacidade'];

  const { formatMessage } = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);

  function onClickHandler() {
    setIsLoading(true);

    saveAcceptanceOfTermsAndPolicies(termsOfUse.id, privacyPolicy.id)
      .then(() => onClose());
  }

  return (
    <>
      <div className="modal terms-and-policies-modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <div className="modal-card-title">
              {formatMessage({ id: "mudancas-termos" })}
            </div>
          </header>
          <section className="modal-card-body">
            {formatMessage({ id: "mudancas-termos-descricao" })}{" "}
            <br/>
            <div className="politica-privacidade">
              <label>
                <input
                  data-testid="accept-terms"
                  type="checkbox"
                  checked={hasAcceptedTerms}
                  onChange={e => setHasAcceptedTerms(e.target.checked)}
                />{" "}
                <span>
                  {formatMessage({ id: "li-e-aceito" })}{" "}
                  <a href="https://buscar.terras.app/app/terms-of-use" target="_blank" rel="noopener noreferrer">
                    {formatMessage({ id: "termos-uso" })}
                  </a>{" "}
                  {formatMessage({ id: "e-a" })}{" "}
                  <a href="https://buscar.terras.app/app/privacy-policy" target="_blank" rel="noopener noreferrer">
                    {formatMessage({ id: "politica-privacidade" })}
                  </a>
                  .
                </span>
              </label>
            </div>
          </section>
          <footer className="modal-card-foot">
            <button
              disabled={!hasAcceptedTerms}
              className={`button primary ${isLoading ? "is-loading" : ""}`}
              onClick={onClickHandler}
            >
              {formatMessage({ id: "continuar" })}
            </button>
          </footer>
        </div>
      </div>
    </>
  );
};

export default TermsAndPoliciesModal;
